import axios from 'axios'
import { AlertPlugin } from 'bootstrap-vue'
import qs from 'qs'
import { debounce } from 'throttle-debounce'
import { Auth0Plugin } from '../auth';

/**
 * 检查dom是否忽略
 * @param {*} e
 */
// const errorMessage = debounce(500, (message, type = 'error') => {
//   AlertPlugin(message,{
//     message: message,
//     duration: 1500,
//     type: type
//   })
// })

// Get the access token from the auth wrapper
// const token = Auth0Plugin.getTokenSilently();
// axios.defaults.headers.post['Authorization'] = `Bearer <%= "${token}" %>`

axios.defaults.headers.post['Content-Type'] = 'application/x-www-form-urlencoded;charset=UTF-8'
axios.defaults.headers.post['api-key'] = 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9'
// 创建axios实例
let hrefs = []
if (window.location.href.indexOf('index.html') != -1) {
  hrefs = window.location.href.split('index.html')
} else {
  hrefs = window.location.href.split('#')
}
// const baseURL = hrefs.length > 0 ? hrefs[0] : window.location.href
const baseURL = 'https://api.proofy-ai.com:8443/'
// baseURL + 'index.php/' 默认请求地址
// process.env.BASE_API 自定义请求地址

window.BASE_URL = process.env.NODE_ENV === 'production' ? baseURL : process.env.BASE_API

const service = axios.create({
  baseURL: window.BASE_URL, // api 的 base_url
  timeout: 180000 // 请求超时时间
})

// request拦截器
service.interceptors.request.use(
  config => {
    const flag = config.headers['Content-Type'] && config.headers['Content-Type'].indexOf('application/json') !== -1
    if (!flag) {
      const mult = config.headers['Content-Type'] && config.headers['Content-Type'].indexOf('multipart/form-data') !== -1
      if (mult) {
        config.data = config.data
      } else {
        config.data = qs.stringify(config.data)
      }
    } else {
      if (config.data === undefined || config.data === null) {
        // 不传参的情况下 json类型的提交数据，校准为 空对象
        config.data = {}
      }
    }
    return config
  },
  error => {
    // Do something with request error
    return Promise.reject(error)
  }
)

// response 拦截器
service.interceptors.response.use(
  response => {
    return response.data
  },
  error => {
    if (error.response) {
      const response = error.response
      if (response.status == 500) {
        // errorMessage('Net error')
      } else if (response.data && response.data.msg) {
        // errorMessage(response.data.msg)
      }
    }
    return Promise.reject(error)
  }
)

export default service



// WEBPACK FOOTER //
// ./src/utils/request.js